const statusCampaign = {
  PENDING_TO_START_DATE: 1,
  ACTIVE: 2,
  FINISHED: 3,
  CANCELED: 4,
};

const statusCampaignString = () => {
  let data = {};
  data[statusCampaign.ACTIVE] = "فعال";
  data[statusCampaign.PENDING_TO_START_DATE] = "در حال انتظار ";
  data[statusCampaign.FINISHED] = "تمام شده";
  data[statusCampaign.CANCELED] = "لغو شده";

  return data;
};
export default { statusCampaign, statusCampaignString };
